import React from "react";
import styled from "styled-components";

export const Page = styled.main`
  color: #172033;
`;

export const Hero = styled.section`
  margin-bottom: 18px;
  padding: 24px 26px;
  border: 1px solid #e4edf8;
  border-radius: 8px;
  background: linear-gradient(135deg, #ffffff 0%, #eef6ff 100%);

  h1 {
    margin: 0 0 8px;
    font-size: 30px;
  }

  p {
    margin: 0;
    color: #66758f;
  }
`;

export const StatGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 14px;
  margin-bottom: 18px;
`;

export const StatCard = styled.article`
  padding: 18px;
  border: 1px solid #e3ebf7;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(32, 72, 122, 0.06);

  svg {
    color: #2f80ed;
  }

  span {
    display: block;
    margin-top: 10px;
    color: #66758f;
    font-size: 13px;
    font-weight: 800;
  }

  strong {
    display: block;
    margin-top: 5px;
    font-size: 24px;
  }
`;

export const Panel = styled.section`
  border: 1px solid #e3ebf7;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(32, 72, 122, 0.07);
  overflow: hidden;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 20px;
    border-bottom: 1px solid #e3ebf7;
  }

  h2 {
    margin: 0;
    font-size: 19px;
  }
`;

export const ListRow = styled.article`
  display: grid;
  grid-template-columns: ${(props) => props.$columns || "1fr 120px 120px"};
  gap: 14px;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #edf2f8;

  &:last-child {
    border-bottom: 0;
  }

  strong {
    display: block;
    color: #172033;
  }

  span {
    color: #66758f;
    font-size: 13px;
  }
`;

export const Badge = styled.span`
  justify-self: start;
  border-radius: 999px;
  padding: 7px 10px;
  background: ${(props) => props.$bg || "#eaf3ff"};
  color: ${(props) => props.$fg || "#2f70cf"};
  font-size: 12px;
  font-weight: 900;
`;

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 38px;
  border: ${(props) => (props.$primary ? "0" : "1px solid #dce6f2")};
  border-radius: 7px;
  padding: 0 13px;
  background: ${(props) => (props.$primary ? "#2f80ed" : "#fff")};
  color: ${(props) => (props.$primary ? "#fff" : "#35445c")};
  font-weight: 900;
  cursor: pointer;
`;

export function AdminPageHeader({ title, description }) {
  return (
    <Hero>
      <h1>{title}</h1>
      <p>{description}</p>
    </Hero>
  );
}
